import { render, staticRenderFns } from "./StakingTimeline.vue?vue&type=template&id=5d89364c&scoped=true&"
import script from "./StakingTimeline.vue?vue&type=script&lang=ts&"
export * from "./StakingTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./StakingTimeline.vue?vue&type=style&index=0&id=5d89364c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89364c",
  null
  
)

export default component.exports